import { HTMLBase } from '../../html/html';

export class UserActionProcess {
  LifeCycleCall: string;
  UserActionID: string;
  Value: any;
  AttributeKey: any;
  InterfaceElementID: string;
  AdditionalAttributes: { attribute: string; value: any }[] = [];
  AdditionaInterfaceElements: any[] = [];
  MultiSelect:boolean;
  ProcessActionOnServer:boolean;
}
